class TextInputView extends Backbone.View
  events: {
    "open": "open"
    "exit": "exit"
    "iostap #text-input-dismiss-btn": "onBlur"
    "input #text-input-area": "onChange"
    "touchmove": "lockScroll"
  }

  initialize: ->
    return unless @el
    if window.navigator.userAgent.match(/iP(ad|hone|od)/)
      @el.classList.add("is-ios")

    @elements = {
      input: @el.querySelector("#text-input-area")
      title: @el.querySelector("#text-input-title")
      prompt: @el.querySelector("#text-input-prompt")
      total: @el.querySelector("#text-input-count-total")
      current: @el.querySelector("#text-input-count-current")
    }

  open: (e, @options = {}) ->
    @border = document.body.scrollTop
    @el.setAttribute('aria-hidden', 'true')
    @el.classList.add("visible")
    @el.classList.toggle("has-min", @options.min > 0)

    @elements.input.value       = @options.value or ""
    @elements.current.innerHTML = @options.value?.length or 0
    @elements.total.innerHTML   = @options.min or 0
    @elements.prompt.innerHTML  = @options.prompt or ""

    @showtimeout = window.setTimeout (=>
      @active = true
      @onChange()
      @elements.input.focus()
      @lockScroll()
      @el.classList.add("active")
      @el.style.borderTop = @el.style.borderBottom = "#{@border}px"
    ), 300

  exit: ->
    window.clearTimeout @showtimeout
    document.activeElement.blur()
    @active = false

    @el.setAttribute('aria-hidden', 'false')
    @el.classList.remove("active")
    @el.classList.remove("visible")
    @trigger("exit")

  onBlur: ->
    return unless @active
    @exit()

  onChange: (e) ->
    return unless @active
    value = @elements.input.value

    window.clearTimeout @changetimeout
    @changetimeout = window.setTimeout (=> @$el.trigger("update", value)), 100
    @elements.current.innerHTML = value.length
    @el.classList.toggle("is-complete", value.length >= @options.min)

  lockScroll: (e) ->
    if @active
      e?.preventDefault() unless e?.target is @elements.input
      document.scrollingElement?.scrollTop = @border
      document.body.scrollTop = @border


module.exports = TextInputView
